import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KpaKendoButtonDirective } from '@app/internal/directives/kpa-button.directive';
import { InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';
import { UploadsModule } from '@progress/kendo-angular-upload';

import { KitchenSinkComponent } from '@app/internal/kitchen-sink/kitchen-sink.component';
import { KpaGridDirective } from '@app/internal/directives/kpa-grid.directive';
import { ODataBindingDirective } from './odata-binding-directive';
import { KpaAppbarComponent } from './components/kpa-appbar/kpa-appbar.component';
import { AppBarModule, NavigationModule } from '@progress/kendo-angular-navigation';
import { IconsModule, SVGIconModule } from '@progress/kendo-angular-icons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { KpaSidenavComponent } from './components/kpa-sidenav/kpa-sidenav.component';
import { DueDatePipe } from './pipes/duedate.pipe';
import { EmployeeService } from './services/employee.service';
import { LanguageService } from './services/language.service';
import { SwitchlanguagesComponent } from './components/switchlanguages/switchlanguages.component';
import { KpaLoaderComponent } from './components/kpa-loader/kpa-loader.component';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { ValidationErrorsComponent } from './validation-errors/validation-errors.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DropDownListFilterComponent } from './components/dropdown-filter/dropdownlist-filter.component';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { ReplaceUnderscoresPipe } from './pipes/replace-underscores.pipe';
import { ChangeToCodePipe } from './pipes/change-to-code.pipe';
import { AnnouncementsCardComponent } from './components/announcements-card/announcements-card.component';
import { InprogressService } from './services/inprogress.service';
import { FileManagementService } from './services/file-management.service';
import { QuestionViewComponent } from './components/audit/question-view/question-view.component';
import { PaginationComponent } from './components/audit/pagination/pagination.component';
import { FileUploadComponent } from './components/audit/file-upload/file-upload.component';
import { PerformAuditComponent } from './components/perform-audit/perform-audit.component';
import { AuditComponent } from './components/audit/audit.component';
import { PagerModule } from '@progress/kendo-angular-pager';

@NgModule({
	declarations: [
		KpaLoaderComponent,
		SwitchlanguagesComponent,
		KpaKendoButtonDirective,
		KpaGridDirective,
		ODataBindingDirective,
		KitchenSinkComponent,
		KpaAppbarComponent,
		KpaSidenavComponent,
		DueDatePipe,
		ValidationErrorsComponent,
		DropDownListFilterComponent,
		ReplaceUnderscoresPipe,
		ChangeToCodePipe,
		AnnouncementsCardComponent,
		QuestionViewComponent,
		PaginationComponent,
		FileUploadComponent,
		PerformAuditComponent,
		AuditComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		InputsModule,
		GridModule,
		ButtonsModule,
		DropDownsModule,
		LayoutModule,
		DialogsModule,
		TextBoxModule,
		LabelModule,
		NavigationModule,
		UploadsModule,
		SVGIconModule,
		DialogsModule,
		MultiSelectModule,
		IconsModule,
		FormsModule,
		ReactiveFormsModule,
		DateInputsModule,
		TextBoxModule,
		NavigationModule,
		TypographyModule,
		NotificationModule,
		ProgressBarModule,
		PagerModule,
	],
	exports: [
		KpaLoaderComponent,
		InputsModule,
		KpaAppbarComponent,
		GridModule,
		ButtonsModule,
		DropDownsModule,
		LayoutModule,
		DialogsModule,
		TextBoxModule,
		LabelModule,
		SVGIconModule,
		DialogsModule,
		IconsModule,
		FormsModule,
		ReactiveFormsModule,
		DateInputsModule,
		TextBoxModule,
		MultiSelectModule,
		NavigationModule,
		TypographyModule,
		UploadsModule,
		PagerModule,
		KpaKendoButtonDirective,
		KpaGridDirective,
		ODataBindingDirective,
		KitchenSinkComponent,
		KpaSidenavComponent,
		DueDatePipe,
		ChangeToCodePipe,
		SwitchlanguagesComponent,
		ValidationErrorsComponent,
		NotificationModule,
		ProgressBarModule,
		DropDownListFilterComponent,
		ReplaceUnderscoresPipe,
		AnnouncementsCardComponent,
		QuestionViewComponent,
		PaginationComponent,
		FileUploadComponent,
		PerformAuditComponent,
		AuditComponent,
	],
	providers: [EmployeeService, LanguageService, InprogressService, FileManagementService],
})
export class SharedModule {}
